import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { selectStkProductionReg } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { StockMenu } from '../TitleList';
import { fetchStkProductionReg, insertStockEntryProduction, updateStockProduction } from '../../Store/PHPSlice/Stock/StockApis';
import { useParams } from 'react-router-dom';

const StkProductionEdit = () => {
    const { Id } = useParams();

    const [formData, setFormData] = useState({
        stkId: Id,
        dt: '',
        stkMemo: '',
        departNm: '',
        item: '',
        streId: '',
        streMemo: '',
        ctreId: '',
        ctreMemo: '',
        stkBarcode: '',
        size: '',
        totQty: '',
        prevQty: '',
        newQty: '',
        userId: '1'
    });

    const dispatch = useDispatch();

    const stkProdReg = useSelector(selectStkProductionReg);

    useEffect(() => {
        dispatch(fetchStkProductionReg(Id));
    }, [dispatch, Id]);


    useEffect(() => {
        if (stkProdReg && stkProdReg?.data) {
            const item = stkProdReg.data;

            setFormData(prev => ({
                ...prev,
                dt: item.dt,
                stkMemo: item.stk_memo,
                departNm: item.departNm,
                item: item.itemNm,
                streMemo: item.streMemo,
                ctreMemo: item.ctreMemo,
                stkBarcode: item.barcode,
                size: item.size,
                prevQty: item.qty,
                totQty: item.totqty,
                streId: item.streId,
                ctreId: item.ctreId
            }));
        }
    }, [stkProdReg]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    // For filteredDepart:

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Convert value to a number if it's a quantity, otherwise leave as string
        const newValue = name === 'newQty' ? Number(value) : value;

        // Check if the name is 'newQty' and if its value is greater than totQty
        if (name === 'newQty' && newValue > formData.totQty) {
            setFormData({
                ...formData,
                [name]: formData.totQty  // Set newQty to the value of totQty
            });
        } else {
            // For other inputs, or if newQty is not greater than totQty, update the formData as usual
            setFormData({
                ...formData,
                [name]: newValue
            });
        }
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function object(formData) {
        const data = {
            stkId: formData.stkId,
            barcode: formData.stkBarcode,
            size: formData.size,
            streId: formData.streId,
            ctreId: formData.ctreId,
            newqty: formData.newQty,
            totqty: formData.totQty,
            userId: formData.userId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const postData = object(formData);
        // console.log(postData)
        dispatch(updateStockProduction(postData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Records Updated");
                window.location.reload();
                window.close();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };
    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Production Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {formData.ctreMemo !== '0' && formData.ctreMemo !== '' ?
                                    <>
                                        {
                                            [
                                                { label: 'Date', name: 'dt', type: 'date' },
                                                { label: 'Stock Memo', name: 'stkMemo', type: 'readOnly' },
                                                { label: 'Department', name: 'departNm', type: 'readOnly' },
                                                { label: 'Cutting Return No.', name: 'ctreMemo', type: 'readOnly' },
                                                { label: 'Item', name: 'item', type: 'readOnly' },
                                                { label: 'Barcode', name: 'stkBarcode', type: 'readOnly' },
                                                { label: 'Size', name: 'size', type: 'readOnly' },
                                                { label: 'Total Qty', name: 'totQty', type: 'readOnly' },
                                                { label: 'Prev. Qty', name: 'prevQty', type: 'readOnly' },
                                                { label: 'New Qty', name: 'newQty' },
                                            ].map((field, index) => (
                                                <Grid item xs={12} md={6} key={index}>
                                                    <Grid container alignItems="center" spacing={1}>
                                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                            <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <FormControl fullWidth>
                                                                {field.type === 'date' ? (
                                                                    <TextField
                                                                        id={field.name}
                                                                        name={field.name}
                                                                        type="date"
                                                                        value={formData[field.name]}
                                                                        onChange={handleDateChange}
                                                                        inputProps={{ style: styled.cutDate }}
                                                                        sx={inputStyles}
                                                                    />
                                                                ) : (
                                                                    <TextField
                                                                        id={field.name}
                                                                        name={field.name}
                                                                        value={formData[field.name]}
                                                                        onChange={handleInputChange}
                                                                        inputProps={{ style: styled.input, readOnly: field.type }}
                                                                        sx={inputStyles}
                                                                    />
                                                                )}
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ))
                                        }
                                    </>

                                    :
                                    <>
                                        {
                                            [
                                                { label: 'Date', name: 'dt', type: 'date' },
                                                { label: 'Stock Memo', name: 'stkMemo', type: 'readOnly' },
                                                { label: 'Department', name: 'departNm', type: 'readOnly' },
                                                { label: 'Stitching Return No.', name: 'streMemo', type: 'readOnly' },
                                                { label: 'Item', name: 'item', type: 'readOnly' },
                                                { label: 'Barcode', name: 'stkBarcode', type: 'readOnly' },
                                                { label: 'Size', name: 'size', type: 'readOnly' },
                                                { label: 'Total Qty', name: 'totQty', type: 'readOnly' },
                                                { label: 'Prev. Qty', name: 'prevQty', type: 'readOnly' },
                                                { label: 'New Qty', name: 'newQty' },
                                            ].map((field, index) => (
                                                <Grid item xs={12} md={6} key={index}>
                                                    <Grid container alignItems="center" spacing={1}>
                                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                            <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <FormControl fullWidth>
                                                                {field.type === 'date' ? (
                                                                    <TextField
                                                                        id={field.name}
                                                                        name={field.name}
                                                                        type="date"
                                                                        value={formData[field.name]}
                                                                        onChange={handleDateChange}
                                                                        inputProps={{ style: styled.cutDate }}
                                                                        sx={inputStyles}
                                                                    />
                                                                ) : (
                                                                    <TextField
                                                                        id={field.name}
                                                                        name={field.name}
                                                                        value={formData[field.name]}
                                                                        onChange={handleInputChange}
                                                                        inputProps={{ style: styled.input, readOnly: field.type }}
                                                                        sx={inputStyles}
                                                                    />
                                                                )}
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ))
                                        }
                                    </>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={formData.newQty == ''}>Update</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StkProductionEdit;
